import { useCallback } from "react";
import { convertTimeInput } from "../../utils/convertTimeInput.js";
function useChangeActions(params) {
  const { updateComponentState, allowUnlistedValues, timeFormat, allowEmpty, options } = params;
  const onSelectChange = useCallback(
    (e) => {
      const clickedElement = e.target;
      updateComponentState({
        timeValue: clickedElement.value,
        open: false
      });
    },
    [updateComponentState]
  );
  const onInputChange = useCallback(
    (e) => {
      const { value } = e.target;
      const parsedInput = convertTimeInput(value, timeFormat, allowEmpty);
      const isInvalid = parsedInput === "invalid" || parsedInput === null && !allowEmpty || !allowUnlistedValues && parsedInput !== null && !options.includes(parsedInput);
      updateComponentState({ open: !isInvalid, inputValue: value });
    },
    [allowUnlistedValues, timeFormat, options, updateComponentState, allowEmpty]
  );
  return { onSelectChange, onInputChange };
}
export {
  useChangeActions
};
//# sourceMappingURL=useChangeActions.js.map
